import type { DublicateClientModel } from '@pages/DublicateClients/types';

import type { BaseOptionType } from 'antd/es/select';

export const dublicateClientsMocks: DublicateClientModel[] = [
  {
    Id: 1,
    UserName: 'Овчинников Фёдор',
    StatusId: 1,
    Clients: [
      {
        ClientId: 101,
        ClientName: 'Келлер Екатерина',
        Phone: '+7 (900) 111-11-11',
        Email: 'keller.ekaterina@example.com',
        VK: 'vk.com/keller_ekaterina',
        Instagram: 'keller_ekaterina',
        Telegram: '@keller_ekaterина',
        Tags: [1, 2],
        RecordsCount: 3,
        SalesCount: 2,
        CreatedAt: '2025-12-12T10:00:00Z',
      },
      {
        ClientId: 102,
        ClientName: 'Екатерина',
        Phone: '+7 (900) 222-22-22',
        Email: null,
        VK: null,
        Telegram: '@ekaterina222',
        Instagram: 'ekaterina222',
        Tags: [3],
        RecordsCount: 1,
        SalesCount: 0,
        CreatedAt: '2025-12-25T09:30:00Z',
      },
      {
        ClientId: 103,
        ClientName: 'Екатерина K',
        Phone: null,
        Email: 'ekaterina.k@example.com',
        VK: 'vk.com/ekaterina_k',
        Telegram: null,
        Instagram: 'ekaterina_k',
        Tags: [1],
        RecordsCount: 2,
        SalesCount: 1,
        CreatedAt: '2026-02-25T08:15:00Z',
      },
    ],
  },

  {
    Id: 2,
    UserName: 'Система',
    StatusId: 2,
    Clients: [
      {
        ClientId: 201,
        ClientName: 'Синсеро Джейн',
        Phone: '+7 (900) 333-33-33',
        Email: 'jane.sincero@example.com',
        VK: null,
        Telegram: null,
        Instagram: null,
        Tags: [4],
        RecordsCount: 2,
        SalesCount: 1,
        CreatedAt: '2025-11-10T11:00:00Z',
      },
      {
        ClientId: 202,
        ClientName: 'Джей',
        Phone: '+7 (900) 333-33-33',
        Email: null,
        VK: 'vk.com/j_djane',
        Tags: [4, 5],
        RecordsCount: 1,
        SalesCount: 0,
        Telegram: '@djane900',
        Instagram: 'djane_vk',
        CreatedAt: '2025-11-12T14:20:00Z',
      },
    ],
  },
  {
    Id: 3,
    UserName: 'Система',
    StatusId: 3,
    Clients: [
      {
        ClientId: 101,
        ClientName: 'Келлер Екатерина',
        Phone: '+7 (900) 111-11-11',
        Email: 'keller.ekaterina@example.com',
        VK: 'vk.com/keller_ekaterina',
        Telegram: '@keller_ekaterина',
        Instagram: 'keller_ekaterина',
        Tags: [1, 2],
        RecordsCount: 3,
        SalesCount: 2,
        CreatedAt: '2025-12-12T10:00:00Z',
      },
      {
        ClientId: 102,
        ClientName: 'Екатерина',
        Phone: '+7 (900) 222-22-22',
        Telegram: '@ekaterina222',
        Instagram: 'ekaterina222',
        Email: null,
        VK: null,
        Tags: [3],
        RecordsCount: 1,
        SalesCount: 0,
        CreatedAt: '2025-12-25T09:30:00Z',
      },
      {
        ClientId: 103,
        ClientName: 'Екатерина K',
        Phone: null,
        Email: 'ekaterina.k@example.com',
        VK: 'vk.com/ekaterina_k',
        Tags: [1],
        Telegram: null,
        Instagram: 'ekaterina_k',
        RecordsCount: 2,
        SalesCount: 1,
        CreatedAt: '2026-02-25T08:15:00Z',
      },
    ],
  },
  {
    Id: 4,
    UserName: 'Овчинников Фёдор',
    StatusId: 4,
    Clients: [
      {
        ClientId: 101,
        ClientName: 'Келлер Екатерина',
        Phone: '+7 (900) 111-11-11',
        Email: 'keller.ekaterina@example.com',
        VK: 'vk.com/keller_ekaterina',
        Telegram: '@keller_ekaterина',
        Instagram: 'keller_ekaterина',
        Tags: [1, 2],
        RecordsCount: 3,
        SalesCount: 2,
        CreatedAt: '2025-12-12T10:00:00Z',
      },
      {
        ClientId: 102,
        ClientName: 'Екатерина',
        Phone: '+7 (900) 222-22-22',
        Telegram: '@ekaterina222',
        Instagram: 'ekaterina222',
        Email: null,
        VK: null,
        Tags: [3, 5, 6, 7, 8],
        RecordsCount: 1,
        SalesCount: 0,
        CreatedAt: '2025-12-25T09:30:00Z',
      },
      {
        ClientId: 103,
        ClientName: 'Екатерина K',
        Phone: null,
        Email: 'ekaterina.k@example.com',
        VK: 'vk.com/ekaterina_k',
        Telegram: null,
        Instagram: 'ekaterina_k',
        Tags: [1],
        RecordsCount: 2,
        SalesCount: 1,
        CreatedAt: '2026-02-25T08:15:00Z',
      },
      {
        ClientId: 104,
        ClientName: 'Екатерина Новикова',
        Phone: '+7 (900) 444-44-44',
        Email: 'ekaterina.novikova@example.com',
        VK: null,
        Telegram: null,
        Instagram: 'ekaterina_novikova',
        Tags: [2, 3],
        RecordsCount: 0,
        SalesCount: 0,
        CreatedAt: '2026-03-10T12:00:00Z',
      },
    ],
  },
];

export const dublicateStatusesMocks: BaseOptionType[] = [
  { value: 1, label: 'На рассмотрении' },
  { value: 2, label: 'Конфликт' },
  { value: 3, label: 'Объединение' },
  { value: 4, label: 'Отмена' },
];
